/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { ExceptionResponseError } from './exception-response-error';
 /**
 *
 *
 * @export
 * @interface ExceptionResponse
 */
export interface ExceptionResponse {

    /**
     * @type {number}
     * @memberof ExceptionResponse
     */
    status: number;

    /**
     * @type {string}
     * @memberof ExceptionResponse
     */
    message: string;

    /**
     * @type {Array<ExceptionResponseError>}
     * @memberof ExceptionResponse
     */
    errors: Array<ExceptionResponseError>;
}
